<template>
  <div>
    <VasionSchedulersPage title="Add to Workflow" />
  </div>
</template>

<script>
export default {
  name: 'AddToWorkflow',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
